module.exports = __webpack_public_path__ + "img/appStore.a0e1f8e9.svg";